import { render, staticRenderFns } from "./CategorySettingView.vue?vue&type=template&id=fc19746e&scoped=true&"
import script from "./CategorySettingView.vue?vue&type=script&lang=js&"
export * from "./CategorySettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc19746e",
  null
  
)

export default component.exports